<template>
  <v-card tabindex="-1" @keydown.esc="$emit('close')" @keydown.enter="$emit('enter')">
    <v-layout column>
      <v-toolbar card  light dense flat>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex v-show="cxt.isFilterMode()" sm4 xs4 >
        <v-text-field
          autofocus
          label="Фильтр"
          v-show="cxt.isFilterMode()"
          v-model="cxt.filterString"
          solo flat
        ></v-text-field>
      </v-flex>
      <v-btn icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
      <v-card-scroll flat :height="calcDialogScroll(48+52)">
        <v-list three-line dense>
          <template v-for="item in this.filteredItems">
            <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
            <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
            <v-list-tile v-else v-bind:key="getItemKey(item)" @click="select(getItemKey(item))">
               <v-list-tile-content>
                <v-list-tile-title  v-html="'<b>' + getItemTitle(item) + '</b>'"></v-list-tile-title>
                <v-list-tile-sub-title v-html='getItemText(item)'></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
                <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
                <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
              <v-list-tile-action-text>{{formats.blank(item.uploaded, formats.formatDate)}}</v-list-tile-action-text>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-scroll>
    <v-card-actions>
      <v-btn @click="ok()">Сохранить</v-btn>
      <!-- <v-btn @click="loadDocs()">Загрузить</v-btn> -->
      <v-spacer></v-spacer>
      <v-ops-btn :cxt="cxt"></v-ops-btn>
      <span tabindex="0" v-on:focus="firstFocus()"></span>      
    </v-card-actions>
  </v-layout>
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import classes from '../../api/classes'
  import depo from '../depo'
  import vCardScroll from '../common/CardScroll'
  import vOpsBtn from '../common/OpsBtn'

  export default {
    name: 'docprop-list',
    components: {vCardScroll, vOpsBtn},
    mixins: [apimix],
    data: () => ({
      cxt: null,
      items: []
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      docprops: {
        type: Array,
        default: function () {
          return []
        }
      },
      title: {
        type: String,
        default: 'Список документов'
      },
      companyRefCode: {
        type: String,
        default: null
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      // cxt.mode = classes.modes.SELECT
      cxt.actionCaption = 'Изменить'
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Добавить из депозитария', null,
        () => this.attachDocs()))
      cxt.actions.push(new classes.Action(this, 'Загрузить в депозитарий',
        null,
        () => this.loadDocs()))
      cxt.selectActions.push(new classes.Action(this, 'Удалить из списка',
        null,
        () => this.deleteItems(cxt.selectedIds)))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectAllAction(cxt))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      this.cxt = cxt
      if (this.selected != null) {
        this.selected.forEach(id => this.cxt.select(id))
      }
    },
    mounted () {
      this.fetchData()
      this.setFocus()
    },
    watch: {
      docprops: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      }),
      orderedItems () {
        // console.log('orderedItems', this.items)
        return this.items.sort((a, b) => this.formats.compareString(this.getItemTitle(a), this.getItemTitle(b)))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(this.getItemTitle(item))
            .concat(this.getItemText(item))
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      }
    },
    methods: {
      setFocus () {
        this.$nextTick(function () {
          if (!this.$el.contains(document.activeElement)) {
            this.$el.focus()
          }
        })
      },
      firstFocus () {
        let input = this.$el.querySelector('input')
        if (input) {
          input.focus()
        } else {
          this.$el.focus()
        }
      },
      getItemKey (item) {
        return item.uid
      },
      fetchData () {
        let docprops = this.docprops
        if (docprops) {
          docprops.forEach(h => {
            let item = {uid: h.uid, docName: h.docName}
            this.items.push(item)
          })
        }
      },
      ok () {
        let docprops = []
        this.items.forEach(i => {
          docprops.push({
            uid: i.uid,
            docName: i.docName
          })
        })
        this.$emit('input', docprops)
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      select (uid) {
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
      },
      click (item) {
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      },
      onSetItems (values) {
        if (Array.isArray(values) && values.length > 0) {
          let set = new Set(values)
          this.items.map(item => item.uid).forEach(v => {
            set.add(v)
          })
          this.$store.dispatch('getDepoFileProps', {uids: Array.from(set)}).then(
            (data) => {
              if (Array.isArray(data)) {
                let items = data.map(item => {
                  return {uid: item.uid, docName: item.docName}
                })
                this.items = items
              }
            },
            () => {}
          )
        }
      },
      attachDocs () {
        let inns = this.companyRefCode ? [this.companyRefCode] : []
        let queryCxt = {path: null, inns: inns}
        depo.selectDoc(this, this.onSetItems, true, queryCxt)
      },
      loadDocs (fieldName, fieldPathName) {
        let path = null
        depo.newFile(path, this.onSetItems)
      },
      deleteItems (ids) {
        this.items = this.items.filter(item => !ids.includes(item.uid))
        this.cxt && this.cxt.toViewMode()
      },
      getItemTitle (item) {
        return item.docName
      },
      getItemText (item) {
        return item.uid
      }
    }
  }
</script>




// WEBPACK FOOTER //
// DocPropList.vue?068ac816